<script>
import useVuelidate from "@vuelidate/core";
import {required, email, minLength} from "@vuelidate/validators";
import {useAuthStore} from "../stores/auth";

export default {
    name: "LoginView",

    setup() {
        return {v$: useVuelidate()};
    },

    data() {
        return {
            heroMsgIdx: 0,
            heroMessages: [
                {type: "user", text: "How much is 8 weeks IELTS preparation?"},
                {
                    type: "bot",
                    text: "8-week IELTS Prep is <strong>CAD 3,440</strong> + CAD 225 enrollment fee. September and October start dates available. Want to know about accommodation too?",
                },
                {type: "user", text: "Yes! And can I apply online?"},
                {
                    type: "bot",
                    text: "Homestay from CAD 1,200/month or student residence from CAD 900/month. And yes — apply 100% online. Shall I send you the application link? 📩",
                },
            ],
            loading: false,
            serverError: "",
            form: {
                email: "",
                password: "",
            },
        };
    },

    validations() {
        return {
            form: {
                email: {required, email},
                password: {required, minLength: minLength(8)},
            },
        };
    },

    methods: {
        async submit() {
            const valid = await this.v$.$validate();
            if (!valid) return;

            this.loading = true;
            this.serverError = "";
            const auth = useAuthStore();
            try {
                await auth.login(this.form);
                this.$router.push("/dashboard");
            } catch (err) {
                this.serverError = err.response?.data?.error || err.response?.data?.title || err.message || "Login failed.";
                console.error("Login failed", err.response || err);
            } finally {
                this.loading = false;
            }
        },
        // ── HERO CHAT ──────────────────────────────────
        runHeroChat() {
            setTimeout(this.addHeroMsg, 1500);
        },

        addHeroMsg() {
            const heroChat = this.getEl("hero-chat");

            if (!heroChat) return;

            if (this.heroMsgIdx >= this.heroMessages.length) {
                setTimeout(() => {
                    heroChat.innerHTML = `
            <div class="chat-bot">
              <div class="chat-av">O</div>
              <div class="chat-bub">
                Hi! I'm ABC School's AI assistant.
              </div>
            </div>
          `;

                    this.heroMsgIdx = 0;

                    setTimeout(this.runHeroChat, 2000);
                }, 4000);

                return;
            }

            const msg = this.heroMessages[this.heroMsgIdx];

            if (msg.type === "bot") {
                const el = document.createElement("div");

                el.className = "chat-bot";

                el.innerHTML = `
          <div class="chat-av">O</div>
          <div class="typing">
            <span></span><span></span><span></span>
          </div>
        `;

                heroChat.appendChild(el);

                setTimeout(() => {
                    el.innerHTML = `
            <div class="chat-av">O</div>
            <div class="chat-bub">${msg.text}</div>
          `;

                    this.heroMsgIdx++;

                    setTimeout(this.addHeroMsg, 1800);
                }, 1200);
            } else {
                const el = document.createElement("div");

                el.className = "chat-user";

                el.innerHTML = `
          <div class="chat-ubub">${msg.text}</div>
        `;

                heroChat.appendChild(el);

                this.heroMsgIdx++;

                setTimeout(this.addHeroMsg, 800);
            }
        },
        getEl(id) {
            return this.$el?.querySelector(`#${id}`) ?? null;
        },
        formatCurrency(value) {
            return `$${Math.round(value).toLocaleString()}`;
        },
    },
    mounted() {
        this.runHeroChat();
    },
};
</script>
<template>
    <div class="login">
        <aside class="login__hero">
            <router-link to="/" class="login__brand">
                <img class="login__logo" src="/assets/images/logo.png" alt="AMS AI Studio" width="200" style="filter: brightness(100)" />
            </router-link>

            <div class="login__screen" id="home-landing" style="all: unset">
                <div class="hero-mascot">
                    <div class="journey-pills">
                        <div class="jp lit jp-tilt-1"><PhChatCircleDots class="jp-icon" :size="14" weight="duotone" />Conversation</div>
                        <div class="jp-arr">→</div>
                        <div class="jp lit jp-tilt-2"><PhTarget class="jp-icon" :size="14" weight="duotone" />Lead Captured</div>
                        <div class="jp-arr">→</div>
                        <div class="jp lit jp-tilt-3"><PhClipboardText class="jp-icon" :size="14" weight="duotone" />Follow-up</div>
                        <div class="jp-arr">→</div>
                        <div class="jp lit jp-tilt-4"><PhCheckCircle class="jp-icon" :size="14" weight="duotone" />Enrolled</div>
                    </div>
                    <div class="preview-wrap">
                        <div class="browser">
                            <div class="browser-bar">
                                <div class="b-dot" style="background: #ff5f56"></div>
                                <div class="b-dot" style="background: #ffbd2e"></div>
                                <div class="b-dot" style="background: #27c93f"></div>
                                <div class="burl"><span>app.amsai.io — ABC School International</span></div>
                            </div>
                            <div class="bb">
                                <div class="bbc">
                                    <div class="bbl">Live Chatbot</div>
                                    <div class="chat-wrap" id="hero-chat">
                                        <div class="chat-bot">
                                            <div class="chat-av">O</div>
                                            <div class="chat-bub">Hi! I'm ABC School's AI assistant. Ask me about programs, pricing, or how to apply. 👋</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="bbc">
                                    <div class="bbl">Lead Pipeline</div>
                                    <div id="hero-leads">
                                        <div class="lead-card lc-hot" id="lc1">
                                            <div class="lc-av"><img src="/assets/images/human/female/female-3.png" alt="Maria Santos" /></div>
                                            <div>
                                                <div class="lc-name">Maria Santos <span class="lc-badge bh">Hot</span></div>
                                                <div class="lc-meta">🇧🇷 Brazil · IELTS</div>
                                            </div>
                                            <div class="lc-score" style="color: var(--red)">91</div>
                                        </div>
                                        <div class="lead-card lc-warm" id="lc2">
                                            <div class="lc-av"><img src="/assets/images/human/male/avatar-8.png" alt="Carlos Ruiz" /></div>
                                            <div>
                                                <div class="lc-name">Carlos Ruiz <span class="lc-badge bw">Warm</span></div>
                                                <div class="lc-meta">🇲🇽 Mexico · Intensive</div>
                                            </div>
                                            <div class="lc-score" style="color: var(--amber)">74</div>
                                        </div>
                                        <div class="lead-card lc-cold" id="lc3">
                                            <div class="lc-av"><img src="/assets/images/human/female/female-8.png" alt="Yuki Tanaka" /></div>
                                            <div>
                                                <div class="lc-name">Yuki Tanaka</div>
                                                <div class="lc-meta">🇯🇵 Japan · Business</div>
                                            </div>
                                            <div class="lc-score" style="color: var(--blue)">58</div>
                                        </div>
                                        <div style="text-align: center; margin-top: 6px; font-size: 10px; color: var(--t3)">+ 309 more this month</div>
                                    </div>
                                </div>
                                <div class="bbc">
                                    <div class="bbl">Enrollment Pipeline</div>
                                    <div class="ps">
                                        <div class="ps-head"><span class="ps-lbl">Contacted</span><span class="ps-cnt">34</span></div>
                                        <div class="ps-card"><span class="ps-flag">🇧🇷</span>Maria Santos<span style="margin-left: auto; font-size: 9px; color: var(--t3)">2d ago</span></div>
                                        <div class="ps-card"><span class="ps-flag">🇯🇵</span>Kenji Mori<span style="margin-left: auto; font-size: 9px; color: var(--t3)">3d ago</span></div>
                                    </div>
                                    <div class="ps">
                                        <div class="ps-head"><span class="ps-lbl">Proposal Sent</span><span class="ps-cnt">9</span></div>
                                        <div class="ps-card"><span class="ps-flag">🇲🇽</span>Ana García<span style="margin-left: auto; font-size: 9px; color: var(--t3)">1d ago</span></div>
                                    </div>
                                    <div class="ps">
                                        <div class="ps-head">
                                            <span class="ps-lbl" style="color: var(--green)">Enrolled ✓</span><span class="ps-cnt" style="color: var(--green); font-weight: 600">19</span>
                                        </div>
                                        <div class="ps-card" style="background: var(--greenl); border-color: rgba(29, 158, 117, 0.2)">
                                            <span class="ps-flag">🇰🇷</span><span style="color: var(--green); font-weight: 500">Ji-Yeon Park</span
                                            ><span style="margin-left: auto; font-size: 9px; color: var(--green)">Today</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="login__hero-body">
                <h1 class="login__headline">From first conversation to enrolled student — one platform</h1>
                <p class="login__sub">
                    AMS AI manages the entire student enrollment journey for schools and recruiters. AI chatbot, lead pipeline, follow-up workflows, and enrollment tracking — all in one integrated
                    flow.
                </p>
            </div>
        </aside>

        <main class="login__form-panel">
            <div class="login__form-wrapper">
                <p class="login__welcome-label">Welcome back</p>
                <h2 class="login__title">Login</h2>
                <p class="login__register-row">
                    Don't have an account?
                    <RouterLink to="/register">Register</RouterLink>
                </p>

                <form class="login__form" @submit.prevent="submit">
                    <div v-if="serverError" class="login__error">{{ serverError }}</div>

                    <div class="login__field" :class="{'login__field--error': v$.form.email.$error}">
                        <div class="login__field-header">
                            <label class="login__label" for="login-email">Email</label>
                        </div>
                        <input id="login-email" v-model="form.email" class="login__input" type="email" placeholder="you@example.com" @blur="v$.form.email.$touch()" />
                        <span v-if="v$.form.email.$error" class="login__field-error">
                            {{ v$.form.email.email?.$invalid ? "Please enter a valid email." : "Email is required." }}
                        </span>
                    </div>

                    <div class="login__field" :class="{'login__field--error': v$.form.password.$error}">
                        <div class="login__field-header">
                            <label class="login__label" for="login-password">Password</label>
                        </div>
                        <input id="login-password" v-model="form.password" class="login__input" type="password" @blur="v$.form.password.$touch()" />
                        <span v-if="v$.form.password.$error" class="login__field-error">
                            {{ v$.form.password.minLength?.$invalid ? "Password must be at least 8 characters." : "Password is required." }}
                        </span>
                    </div>

                    <button class="login__submit" type="submit" :disabled="loading">
                        {{ loading ? "Signing in..." : "Login" }}
                        <span v-if="!loading">→</span>
                    </button>
                </form>
            </div>

            <footer class="login__footer">© 2026 AMS AI Studio</footer>
        </main>
    </div>
</template>
